import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'

import { BACKEND_URL } from '../../../../util/api'
import currentUserHasAccess from '../../../../util/widget-helper'
import { REFUND_SEPA_TRANSFER_WIDGET } from '../../../process/ui-definition/process-ui'

const DOWNLOAD_SEPA_TRANSFER = BACKEND_URL + '/api/sepa/download-sepa-transfer-xml?sepaTransferId='

const RefundSepaTransferWidget = ({ context }) => {
    if (!currentUserHasAccess(REFUND_SEPA_TRANSFER_WIDGET)) {
        return null
    }

    if (!context.sepaTransferId) {
        return null
    }

    return (
        <ContentBox title="Refund with Sepa Transfer File">
            <Row>
                <Column size={12}>
                    <a href={DOWNLOAD_SEPA_TRANSFER + context.sepaTransferId}>Download SEPA File</a>
                </Column>
            </Row>

        </ContentBox>
    )
}

RefundSepaTransferWidget.propTypes = {
    context: PropTypes.object.isRequired,
}

export default RefundSepaTransferWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/RefundSepaTransferWidget.js